import { axiosClient } from '../../client';

export const loginBanners = () => {
  return axiosClient.get('starlink/public/banner_login');
};
